<template>
  <div class="container">
    <div class="header">
      <navBar></navBar>
    </div>
    <div class="main-wrapper">
      <div class="card">
        <el-menu class="el-menu" router :default-active="$route.path">
          <myitem :data="routerData"></myitem>
        </el-menu>
      </div>
      <div class="main">
        <router-view :key="$route.path"> </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import myitem from "./menuItem/index.vue";
import routerList from "@/router/photoCasually/pc";
import navBar from "./headerLogo/index.vue";
import api from "@/apis/medal";
export default {
  name: "gzhpc",
  components: {
    myitem,
    navBar
  },
  data() {
    return {
      routerData: []
    };
  },
  computed: {
    routes() {
      return routerList;
    }
  },
  created() {
    this.queryData();
  },
  mounted() {},
  methods: {
    // 获取列表数据
    queryData() {
      api
        .queryMedalUserPermission({ name: this.$store.state.userInfo.username })
        .then(res => {
          if (res.code == 200) {
            this.routerData = this.filterData(
              routerList[0].children,
              res.data.list
            );
          }
        });
    },
    // 过滤
    filterData(data, dataList) {
      const list = data?.filter(item => {
        if (item.path == "/medal/badgeManage") {
          if (dataList.length > 0 && dataList[0]?.administrators) {
            item.show = true;
          } else {
            if (dataList[0]?.medalRecord) {
              item.show = true;
            } else {
              item.show = false;
            }
          }
        } else {
          item.show = true;
        }
        item.children = this.filterData(item.children);

        return item;
      });
      return list;
    }
  }
};
</script>

<style lang="scss">
.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  .header {
    padding: 0;
    height: 112px;
  }
  .main-wrapper {
    flex: 1;
    display: flex;
    .card {
      width: 350px;
      border: 1px solid #00ada7;
      background-color: #00ada7;
      overflow: hidden;
      color: #303133;
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    }
    .el-menu {
      border: 0;
      width: 350px;
      color: #fff;
      background-color: #00ada7;
      margin-top: 100px;
      height: calc(100vh - 216px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .el-menu-item {
        color: #fff;
        text-align: left;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .el-submenu__title {
        text-align: left;
      }
      .el-menu-item.is-active {
        background-color: #00ada7;
        i {
          color: #f7f9fa;
        }

        span {
          color: #008754;
        }
      }
      //设置选鼠标指针浮动在一级菜单的设置
      .el-menu-item:hover {
        background-color: #00ada7 !important;
      }
      span {
        font-size: 29px;
        white-space: normal;
        word-break: break-all;
        line-height: 30px;
        // flex: 1;
      }
    }
    .main {
      width: calc(100% - 350px);
    }
  }
}
</style>
